import { FC, PropsWithChildren } from 'react'

import { Cache, SWRConfig } from 'swr'

import { StorageKeys } from '../../../constants/StorageKeys'
import Fetcher from '../../../services/Fetcher'

/**
 * SWR local cache provider. Prevents revalidation on every refresh.
 * If the page is refreshed within 1 minute, it will use the cache
 * from local storage. After 1 minute, it will revalidate the data
 * and store it in local storage again on page unload.
 */
const localStorageProvider = (): Cache => {
  const store = JSON.parse(localStorage.getItem(StorageKeys.SWRCache) || '[]')
  const map = new Map<string, any>(store || [])

  window.addEventListener('beforeunload', () => {
    localStorage.setItem(StorageKeys.SWRCache, JSON.stringify(Array.from(map.entries())))
  })

  return map
}

export const SWRConfigProvider: FC<PropsWithChildren<{}>> = ({ children }) => (
  <SWRConfig
    value={{
      fetcher: Fetcher.get,
      provider: typeof window !== 'undefined' ? localStorageProvider : () => new Map(),
      revalidateOnFocus: false,
      revalidateIfStale: true,
    }}
  >
    {children}
  </SWRConfig>
)
